export default __webpack_public_path__ + "build/4930a75df93c8f7f4ee79fe9e7b906b9.svg";